import React from 'react';
import styled from 'styled-components';

interface SettingsPreviewSectionProps {
  label: string;
  children: React.ReactNode;
}

export const SettingsPreviewSection: React.FC<SettingsPreviewSectionProps> = ({
  label,
  children,
}) => (
  <PreviewSection>
    <PreviewContent>{children}</PreviewContent>
    <PreviewLabel>{label}</PreviewLabel>
  </PreviewSection>
);

const PreviewSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: center;
  gap: 6px;
  padding-top: 12px;
  width: 150px;
`;

const PreviewContent = styled.div`
  width: 100%;
  aspect-ratio: 145 / 79;
  border-radius: 4px;
  overflow: hidden;

  & > div {
    width: 100%;
    height: 100%;
  }
`;

const PreviewLabel = styled.p`
  color: var(--text-secondary);
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 159%;
  margin: 0;
`;
